import { render, staticRenderFns } from "./SponsorListComponent.vue?vue&type=template&id=b35748b6&"
import script from "./SponsorListComponent.vue?vue&type=script&lang=js&"
export * from "./SponsorListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports